const STATE_IDENTIFIER = 'signup-state'

export const loadState = () => {
    try {
        const serializedState = localStorage.getItem(STATE_IDENTIFIER)
        if (serializedState === null)
            return undefined
        return JSON.parse(serializedState)
    } catch(e) {
        return undefined
    }
}

export const saveState = (state) => { 
    try {
        const serializedState = JSON.stringify(state)
        localStorage.setItem(STATE_IDENTIFIER, serializedState)
    } catch(e) {
        //Ignore 
    }
}

export const clearState = () => {
    try {
        localStorage.removeItem(STATE_IDENTIFIER)
    } catch(e) {
        //Ignore
    }
}